import type { ReactNode } from 'react';

import { SealPercentIcon } from '@phosphor-icons/react';

import type { GiftAmount } from '../../_utils/schema';

export const BLACKFRIDAY_GIFT_AMOUNT_PRICES: Record<GiftAmount, number> = {
  1: 10,
  3: 30,
  6: 50,
  12: 90,
};

export const BLACKFRIDAY_GIFT_AMOUNT_OPTIONS: { value: GiftAmount; label: ReactNode }[] = [
  {
    value: 3,
    label: <div className="flex items-center gap-2 text-[12px] md:text-[14px]">3 months - $30</div>,
  },
  {
    value: 6,
    label: (
      <div className="flex items-center gap-2 text-[12px] md:text-[14px]">
        6 months - <span className="text-gray-500 line-through">$60</span> $50
      </div>
    ),
  },
  {
    value: 12,
    label: (
      <div className="flex items-center gap-2 text-[12px] md:text-[14px]">
        12 months - <span className="text-gray-500 line-through">$120</span> $90{' '}
        <div className="inline-flex items-center gap-1 rounded-full bg-role-success-container px-2 py-1 font-medium text-[12px] leading-3.5">
          <SealPercentIcon size={14} weight="fill" />
          Best deal
        </div>
      </div>
    ),
  },
];
